import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function Login() {
	const navigate = useNavigate();

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		const redirect = queryParams.get('redirect');
		navigate(redirect || '/', { replace: true });
	}, [navigate]);

	return null;
}
